import { ToggleButtonComponentSpacing, ToggleButtonLayoutStyle, YesNoToggleButton } from '@apply/components';
import { useWizardDemoStore } from '../../../../../state/wizardDemoStore';

export const SelfOwnedField = () => {
    const value = useWizardDemoStore((state) => state.property.selfOwned);
    const updateProperty = useWizardDemoStore((state) => state.updateProperty);

    return (
        <YesNoToggleButton
            id='propertySelfOwned'
            value={value}
            onItemClick={(e) => updateProperty({ selfOwned: e?.itemData?.id === 'Yes' })}
            label='Self Owned?'
            required={true}
            layoutStyle={ToggleButtonLayoutStyle.Horizontal}
            height='32px'
            componentSpacing={ToggleButtonComponentSpacing.StandardSpacing}
        />
    );
};
